module.exports = __webpack_public_path__ + "img/aandcon_thumbnail.0ff5f3cf.jpg";